// extracted by mini-css-extract-plugin
export default {"module":"JkhYbc3MhSCqJ3Wpd_9b"};